document.addEventListener('click', (event: MouseEvent) => {
  const target = event.target as HTMLElement;

  document.querySelectorAll<HTMLDetailsElement>('.ce-add-to-calendar__details[open]').forEach((details) => {
    if (!details.contains(target)) {
      details.removeAttribute('open');
    }
  });
});